export default __webpack_public_path__ + "b9ff1586d1583228aed56178e734418a.svg";